<template>
  <div class="navbar">
    <!-- logo -->
    <!-- <div class="leftDiv">
      <div class="logo" @click="logoFun">
        <img src="/static/img/logo_zs.png" />
      </div>
    </div> -->
    <!-- 菜单列表 -->
    <div class="middleDiv">
      <ul class="supUl">
        <li
          v-for="(item, index) in getMenuList(menuList)"
          :key="item.name"
          :index="index"
          class="supLi"
          @click="routerFun(item.path, item.redirect, index)"
        >
          <div v-if="!item.hidden" :class="{ active: index == oindex }">
            <!-- :class="supMenuColor === item.path ? 'subLi-active-color' : ''" -->
            <!-- <svg-icon v-if="index == oindex" :icon-class="item.meta.icon + '-active'" /> -->
            <!-- <svg-icon v-else :icon-class="item.meta.icon" /> -->
            <svg-icon :icon-class="item.meta.icon" />
            <span class="title">{{ item.meta.title }}</span>
            <img
              v-if="item.children && getMenuList(item.children).length"
              :src="
                menuIndex === index
                  ? '/static/img/up.png'
                  : '/static/img/down3.png'
              "
              class="arrow"
            />
          </div>
          <div
            class="subMenu"
            :style="
              menuIndex === index ? 'display: block;transition: all 2s;' : ''
            "
            v-if="item.children && getMenuList(item.children).length"
          >
            <ul class="subUl">
              <li
                v-for="(zitem, zindex) in getMenuList(item.children)"
                :key="zitem.name"
                :zindex="zindex"
                @click.stop="subRouterFun(item.path, zitem.path)"
                :class="
                  subMenuColor === item.path + '/' + zitem.path
                    ? 'subLi-active'
                    : 'subLi'
                "
              >
                <span>{{ zitem.meta.title }}</span>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <!-- 右侧 用户 -->
    <div class="rightDiv">
      <!-- 用户退出下拉 -->
      <!-- <el-dropdown class="avatar-container" trigger="click">
                <div class="avatar-wrapper">
                    <div class="user">
                        <div class="squert">
                            <svg-icon icon-class="defaulthead" class="user-img" />
                        </div>
                        <div class="text">{{ userName }}</div>
                        <i class="el-icon-arrow-down"></i>
                    </div>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item><div @click="goRoute">首页</div></el-dropdown-item>
                    <el-dropdown-item><div @click="goOut">退出登录</div></el-dropdown-item>
                </el-dropdown-menu>
      </el-dropdown>-->
    </div>
  </div>
</template>
<script>
import SvgIcon from "@/components/SvgIcon";
export default {
  components: {
    SvgIcon,
  },
  data() {
    return {
      menuList: [],
      userName: "",
      menuIndex: null,
      menuPath: "",
      oindex: 0,
      open: false,
    };
  },
  computed: {
    supMenuColor() {
      return this.$route.path.substr("/", this.$route.path.lastIndexOf("/"));
    },
    subMenuColor() {
      return this.$route.path;
    },
  },
  created() {
    this.menuList = this.$store.state.routers;
    // console.log(this.menuList)
    let url = this.$route.path;
    this.userName = localStorage.getItem("userName");
  },
  methods: {
    routerFun(path, redirect, index) {
      if (this.oindex == index) {
        this.open = !this.open;
      } else {
        this.oindex = index;
        this.open = true;
      }

      this.menuIndex = index;
      if (!this.open) {
        this.menuIndex = null;
      }

      if (redirect === "home") {
        this.$router.push({
          path: "Home",
        });
        return;
      }
    },
    subRouterFun(supPath, subPath) {
      this.$router.push({
        path: supPath + "/" + subPath,
      });
    },
    getMenuList(arr) {
      return arr.filter((item) => !item.hidden);
    },
    goRoute() {
      this.$router.push("/");
    },
    goOut() {
      localStorage.setItem("userInfo", "");
      localStorage.setItem("codeList", "");
      this.$store.commit("clear_addRoles");
      this.$router.push("/login");
    },
    logoFun() {
      this.$router.push({
        path: "Home",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}
.navbar {
  overflow-y: scroll;
  width: 220px;
  height: 100%;
  font-size: 15px;
  background: #fff;
  // display: flex;
  // justify-content: space-around;
  box-sizing: border-box;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.17);
  margin: auto;
  .leftDiv {
    position: fixed;
    width: 220px;
    height: 90px;
    background: #fff;
    z-index: 5;
    text-align: center;
    line-height: 60px;
    padding: 20px 0 0 0;
    box-sizing: border-box;
    .logo {
      img {
        vertical-align: middle;
      }
    }
  }
  .menu {
    border: none;
  }
  .middleDiv {
    // margin-top: 90px;
    border: none;
    .supUl {
      // display: flex;
      // justify-content: center;
      margin: 0;
      height: 100%;
      line-height: 50px;
    }
    .supLi {
      font-size: 15px;
      text-align: left;
      text-indent: 16px;
      color: #222222;
      // padding: 10px 0 0 0;
      // margin: 10px 0 0 0;
      .subMenu {
        width: 100%;
        height: 100%;
        // opacity: 0;
        display: none;
        color: #959595;
        transition: all 0.2s;
        .subUl {
          top: 60px;
          left: 0;
          margin: auto;
          background: #f8f8f8;
          border-radius: 2px;
          .subLi {
            color: #666666;
            padding: 10px 10px 10px 55px;
            line-height: 1.2;
            text-align: left;
            span {
              font-size: 14px;
              text-indent: 0;
              display: block;
              width: auto;
            }
          }
          .subLi:hover {
            color: #4a90e2;
          }
          .subLi-active {
            color: #fff;
            background: #4a90e2;
            padding: 10px 10px 10px 55px;
            line-height: 1.2;
            text-align: left;
            span {
              font-size: 14px;
              text-indent: 0;
              display: block;
              width: auto;
            }
          }
          .subLi-active:hover {
            color: #d3dbf4;
          }
        }
      }
      .subMenuActive1 {
        display: block !important;
      }
      .triangle {
        position: relative;
      }
      .svg-icon {
        font-size: 16px;
      }
      .title {
        display: inline-block;
        // width: 100px;
        font-weight: 600;
      }
      & div:nth-child(1) {
        position: relative;
        .arrow {
          position: absolute;
          top: 20px;
          right: 20px;
        }
      }
    }
    .supLi:hover {
      color: #222222;
      // background: #edf5f9;
      cursor: pointer;
      // transition: all 0.2s;
      // .subMenu {
      // visibility: visible;
      // opacity: 1;
      // }
      .triangle::after {
        content: "";
        position: absolute;
        bottom: -4px;
        left: 45%;
        width: 0px;
        height: 0px;
        border-bottom: 7px solid #ffffff;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
      }
      // & div:nth-child(1) {
      //     background: #edf5f9;
      // }
    }
    .subLi-active-color {
      color: #fff;
      // background: #796aee;
      position: relative;
    }
    .subLi-active-color:hover {
      color: #fff;
      // background: #796aee;
    }
    .active {
      // color: #fff;
      // background: #796aee;
      // background: #4A90E2;

      position: relative;
      // border-left: 6px solid #4C3DC2;
      // text-indent: 10px;
    }
    .active:hover {
      color: #222222;
      // background: #796aee;
    }
    .active .title {
      // margin-left: 6px;
    }
  }
  .rightDiv {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #979797;
    font-size: 14px;
    // box-sizing: border-box;
    i {
      font-size: 25px;
      color: #979797;
    }
    .latter {
      width: 52px;
    }
    .bell,
    .latter,
    .user,
    .avatar-wrapper:hover {
      cursor: pointer;
    }
    .bell,
    .latter {
      position: relative;
      top: 4px;
      .badge {
        position: relative;
        top: -10px;
        right: 15px;
        border: none;
        /deep/.el-badge .el-badge__content {
          border: none;
        }
      }
    }
    .user {
      display: flex;
      align-items: center;
      border-radius: 2px;
      padding: 5px 8px;
      font-size: 16px;
      color: #aeb9d8;
      .squert {
        width: 26px;
        height: 26px;
        border-radius: 50%;
        .user-img {
          width: 100%;
          height: 100%;
        }
      }
      .text {
        padding: 8px;
      }
    }
    .avatar-container {
      i {
        font-size: 8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Siderbar/index.vue